import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container mx-auto" };
const _hoisted_2 = { class: "grid grid-cols-12 grid-rows-9 gap-4" };
import Skeleton from 'primevue/skeleton';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormSkeleton',
    props: {
        rows: { default: 9 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.rows >= 1)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 0,
                            class: "col-span-6 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 1)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 1,
                            class: "col-span-6 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 2)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 2,
                            class: "col-span-6 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 2)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 3,
                            class: "col-span-6 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 3)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 4,
                            class: "col-span-12 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 4)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 5,
                            class: "col-span-12 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 5)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 6,
                            class: "col-span-4 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 5)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 7,
                            class: "col-span-8 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 6)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 8,
                            class: "col-span-4 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 6)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 9,
                            class: "col-span-4 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 6)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 10,
                            class: "col-span-4 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 7)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 11,
                            class: "col-span-12 mb-2",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 8)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 12,
                            class: "col-span-12 mb-2",
                            height: "4rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 9)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 13,
                            class: "col-span-6",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.rows >= 9)
                        ? (_openBlock(), _createBlock(_unref(Skeleton), {
                            key: 14,
                            class: "col-span-6",
                            height: "2rem"
                        }))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
